import styled, { css } from 'styled-components';
import { variant, color, ColorProps } from 'styled-system';

import { ThemeUtilities } from '../../../theme';

import { HeadingVariant } from './types';
import { fontSmoothing } from '../../../mixins';

type HeadingProps = {
  variant: HeadingVariant;
} & ColorProps;

export const Text = styled.h1<HeadingProps>`
  margin: 0;
  padding: 0;
  font-style: normal;

  ${fontSmoothing};
  ${color};
  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Heading', 'variant'))};
  ${css((props) => ThemeUtilities.getComponentCSSOverrides(props, 'Heading'))};
`;
